import api from '../api';

/**
 * Fetch establishments by SIREN
 * @param siren The SIREN to fetch establishments for
 * @param page Page number for pagination
 * @param limit Number of items per page
 * @returns The establishments and pagination info
 */
export const getEstablishmentsBySiren = async (
  siren: string,
  page: number = 1,
  limit: number = 20
) => {
  try {
    const response = await api.get(`/etablissements/siren/${siren}`, {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching establishments by SIREN:', error);
    throw error;
  }
}; 